import {
  ColumnDef,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';

import { useTableContext } from '@/contexts/table-context';

interface UseDataTableProps<TData> {
  columns: ColumnDef<TData>[];
  data: TData[];
  rowCount: number;
  externalIdKey?: keyof TData;
}

export function useDataTable<TData>({
  columns,
  data,
  rowCount,
  externalIdKey,
}: UseDataTableProps<TData>) {
  const {
    pagination,
    setPagination,
    rowSelection,
    setRowSelection,
    sorting,
    setSorting,
  } = useTableContext();

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),

    // Pagination options
    manualPagination: true,
    onPaginationChange: setPagination,
    rowCount,

    // Selection options
    onRowSelectionChange: setRowSelection,
    getRowId: (row, index) =>
      externalIdKey ? String(row[externalIdKey]) : String(index),

    // Sorting options
    manualSorting: true,
    onSortingChange: setSorting,

    state: {
      pagination,
      rowSelection,
      sorting,
    },
  });

  return { table };
}
